import { useState } from "react";
import { ChevronDown } from "lucide-react";
import type { FAQItem } from "~/marketing/data/personas";
import { SchemaMarkup } from "./SchemaMarkup";
import { faqSchema } from "~/marketing/lib/schema";
import { cn } from "~/marketing/lib/utils";

export function FAQSection({ items }: { items: FAQItem[] }) {
  return (
    <section>
      <SchemaMarkup data={faqSchema(items)} />
      <h2 className="font-display text-2xl font-extrabold tracking-[-0.025em] text-ink sm:text-3xl">
        Frequently Asked Questions
      </h2>
      <div className="mt-6 space-y-3">
        {items.map((item, i) => (
          <FAQAccordionItem key={i} item={item} />
        ))}
      </div>
    </section>
  );
}

function FAQAccordionItem({ item }: { item: FAQItem }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="ss-card-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
        aria-expanded={open}
      >
        <span className="font-display font-bold text-ink">{item.question}</span>
        <span
          className={cn(
            "flex h-7 w-7 shrink-0 items-center justify-center rounded-md border-2 border-ink transition-colors",
            open ? "bg-brand-gold" : "bg-card"
          )}
        >
          <ChevronDown
            className={cn(
              "h-4 w-4 text-ink transition-transform",
              open && "rotate-180"
            )}
          />
        </span>
      </button>
      {open && (
        <div className="border-t-2 border-dashed border-ink/20 px-5 py-4 leading-relaxed text-sub">
          {item.answer}
        </div>
      )}
    </div>
  );
}
